/**
 * Adresse d'un service backend.
 *
 * En local (http://localhost:4400) on garde l'URL directe : rien ne change.
 * Servie par un tunnel HTTPS, la page est en https alors que les vhosts WAMP sont
 * en http:// : le navigateur bloque l'appel (« Mixed Content ») et l'application
 * ne fait plus rien, sans le moindre message dans l'interface. On passe alors par
 * le proxy du serveur de dev, same-origin donc HTTPS lui aussi.
 *
 * La cle doit correspondre a celle de SERVICES dans vue.config.js.
 *
 * Module a part, et non une fonction d'Api.ts : Helper.ts en a besoin et Api.ts
 * importe Helper.ts — les mettre ensemble ferait un cycle d'imports.
 *
 * Ne concerne QUE le developpement : en production les URL sont deja en https.
 */
export function serviceUrl(key: string, url?: string): string {
    const direct = url || ''
    if (typeof window === 'undefined') return direct
    if (window.location.protocol !== 'https:') return direct
    if (!direct.startsWith('http://')) return direct
    return '/_svc/' + key + '/'
}
